import React from "react"
import { useTranslation } from "react-i18next"

export default function CustomNoRowsOverlay({ translationFile, label }) {
  const { t } = useTranslation(translationFile)
  return <span>{t(label)}</span>
}
